import React from 'react';
import { IconProps } from '.';

const SvgColoredMoneyBag = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#F2AB6D'
        d='M14.464 5.12c1.032-.331 2.203-1.631 2.203-2.587 0 0 0-1.334-1.333-1.334-.506 0-.718.196-.912.375-.165.152-.316.292-.621.292-.277 0-.404-.115-.553-.249-.211-.189-.466-.418-1.247-.418-.781 0-1.036.229-1.247.418-.15.135-.277.249-.553.249-.306 0-.457-.14-.621-.292-.195-.179-.407-.375-.913-.375-1.333 0-1.333 1.334-1.333 1.334 0 .955 1.17 2.255 2.202 2.586a9.597 9.597 0 0 0-7.047 8.007l-.565 4.239a4.8 4.8 0 0 0 4.758 5.434h10.635a4.8 4.8 0 0 0 4.758-5.434l-.566-4.24a9.597 9.597 0 0 0-7.045-8.005Z'
      />
      <path
        fill={color}
        d='M15.719 10.697a.8.8 0 0 1 .55.988l-.42 1.481h.651a.8.8 0 0 1 0 1.6h-1.105l-.828 2.92a.8.8 0 0 1-1.532.021l-1.13-3.58-1.128 3.58a.8.8 0 0 1-1.539-.045l-.73-2.895H7.5a.8.8 0 0 1 0-1.6h.604l-.38-1.505a.8.8 0 0 1 1.552-.391l.823 3.264 1.044-3.309a.8.8 0 0 1 1.526 0l1.088 3.452.974-3.43a.8.8 0 0 1 .988-.55Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M7.6 4.8a.8.8 0 0 1 .8-.8h7.2a.8.8 0 0 1 0 1.6H8.4a.8.8 0 0 1-.8-.8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredMoneyBag;
